import React from "react";
import { Typography, Divider, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ArrowRightOutlined,
  LinkOutlined,
  CaretRightFilled,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getIndustries } from "../api/homeApi";
import _ from "../lib/loadlash";
import { useMediaQuery } from "react-responsive";


const { Title, Paragraph, Text } = Typography;

const ListItem = ({ text }) => (
  <div className="industry-list-item">
    <CaretRightFilled className="industry-card-list-bullet" />
    <Text className="industry-list-text">{text}</Text>
  </div>
);

const Industries = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      const { data, errors } = await getIndustries();
      if (!_.isEmpty(errors)) {
        console.error("Error fetching home data:", errors);
        return;
      }
      setContent(data?.data);
    };

    fetchContent();
  }, []);

  const renderSection = (title, contentArray) => (
    <>
      <Text strong className="industry-card-section-title">
        {title}
      </Text>
      {contentArray?.[0]?.children?.map((item, idx) => (
        <ListItem key={idx} text={item.children?.[0]?.text || ""} />
      ))}
    </>
  );

  return (
    <div style={{ marginTop: "110px", background: "white" }}>
      <div
        className="industries-title-overlay"
        data-aos="fade-down"
        data-aos-duration="700"
      >
        <div className="industries-hero-title">{content?.Title}</div>
        <div className="industries-hero-subtitle">{content?.SubTitle}</div>
      </div>

      <div className="section-content service-main-dev" >
        <Row gutter={[50, 50]} justify={"space-evenly"} style={isMobile ? { marginTop: "50px" } : { padding: "0" }}>
          {content?.Industry?.map((industry, index) => (
            <Col sm={24} md={12} lg={8} key={industry.id}>
              <div
                className="saral-gradient-border"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
                data-aos-duration="700"
                // data-aos-delay={100 + index * 100}
              >
                <div className="industry-card" style={{ padding: "1rem" }}>
                  <div className="saral-card-content">
                    <div className="saral-circle-image-container">
                      <div className="saral-circle-image" />
                      <Button
                        type="primary"
                        shape="circle"
                        icon={<LinkOutlined />}
                        size="small"
                        className="saral-image-icon"
                      />
                    </div>

                    <div className="industries-card-title">{industry?.Title}</div>

                    {industry?.ContentSection?.map((section, idx) => (
                      <React.Fragment key={section?.id}>
                        {idx !== 0 && <Divider className="industry-card-divider"/>}
                        {renderSection(section?.Title, section?.Content)}
                      </React.Fragment>
                    ))}
                  </div>

                  <Button
                    type="primary"
                    shape="circle"
                    icon={<ArrowRightOutlined />}
                    size="large"
                    className="industry-card-bottom-arrow"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Industries;
